window.addEventListener('load', function () {
  var _learnq = window._learnq || []
  function addedToCart() {
    fetch(`${window.location.origin}/cart.js`).then((res) =>
      res
        .clone()
        .json()
        .then((data) => {
          var cart = {
            total_price: data.total_price / 100,
            $value: data.total_price / 100,
            total_discount: data.total_discount,
            original_total_price: data.original_total_price / 100,
            items: data.items,
          }
          if (item !== 'undefined') {
            cart = Object.assign(cart, item)
          }
          if (klAjax) {
            _learnq.push(['track', 'Added to Cart', cart])
            klAjax = false
          }
        })
    )
  }

  ;(function (ns, fetch) {
    ns.fetch = function () {
      const response = fetch.apply(this, arguments)
      response.then((res) => {
        if (`${window.location.origin}/cart/add.js`.includes(res.url)) {
          addedToCart()
        }
      })
      return response
    }
  })(window, window.fetch)
  var klAjax = true
  var atcButtons = document.querySelectorAll('product-form__submit')

  for (var i = 0; i < atcButtons.length; i++) {
    atcButtons[i].addEventListener('click', function () {
      if (klAjax) {
        _learnq.push(['track', 'Added to Cart', item])
        klAjax = false
      }
    })
  }

  const selectors = {
    incQty: '.pdp__info__details__add__form__qty-group__inc',
    decQty: '.pdp__info__details__add__form__qty-group__dec',
    qtyInput: '.pdp__info__details__add__form__qty-group__input',
    atcForm: '.pdp__info__details__add__form',
    variantInput: '.pdp__info__details__add__form__group__id',
    suggestionSliderPrevBtn: '.pdp__suggestions__header__btns__prev',
    suggestionSliderNextBtn: '.pdp__suggestions__header__btns__next',
    ingredientAboutOverlayTop:
      '.pdp__ingredients__content__slider__wrapper__item__top__overlay__about',
    ingredientOriginOverlayTop:
      '.pdp__ingredients__content__slider__wrapper__item__top__overlay__origin',
    ingredientAboutBtn:
      '.pdp__ingredients__content__slider__wrapper__item__info__btn__about',
    ingredientOriginBtn:
      '.pdp__ingredients__content__slider__wrapper__item__info__btn__origin',
    variantSelect: '.pdp__info__details__add__form__variants__select',
    priceText: '.pdp__info__details__header__price__text',
    aboutCloseBtn:
      '.pdp__ingredients__content__slider__wrapper__item__top__overlay__about__close',
    originCloseBtn:
      '.pdp__ingredients__content__slider__wrapper__item__top__overlay__origin__close',
    ingredientTopWrapper:
      '.pdp__ingredients__content__slider__wrapper__item__top',
    subscriptionCheckbox: '.rc-checkbox__input',
    productForm: '#product-form-product',
    afterpay: '.afterpay-paragraph',
    oosForm: '.js-oos-form',
    oosEmailInput: '.js-oos-email-input',
    oosSuccessMsg: '.pdp__oos div',
  }

  // const targetNode = document.querySelector(selectors.productForm);
  // const observerOptions = {
  //   childList: true,
  //   attributes: true,
  //   subtree: true
  // }

  // const observer = new MutationObserver(callback);
  // observer.observe(targetNode, observerOptions);

  // function callback() {
  //   if (document.querySelector(selectors.subscriptionCheckbox)) {
  //     observer.disconnect();

  //     document.querySelector(selectors.subscriptionCheckbox).addEventListener('change', function(e) {
  //       if (e.target.checked === true) {
  //         document.querySelector(selectors.afterpay).classList.add('hidden');
  //       } else {
  //         document.querySelector(selectors.afterpay).classList.remove('hidden');
  //       }
  //     });
  //   }
  // }

  const ingredientAboutBtns = document.querySelectorAll(
    selectors.ingredientAboutBtn
  )
  const ingredientOriginBtns = document.querySelectorAll(
    selectors.ingredientOriginBtn
  )
  const ingredientTopWrappers = document.querySelectorAll(
    selectors.ingredientTopWrapper
  )

  const pdpSliderOne = new Swiper('.pdp-slider-one', {
    slidesPerView: 1.2,
    spaceBetween: 8,
    grabCursor: true,
  })

  const ingredientsNavPrev = document.querySelector(
    '.pdp__ingredients__header__slider-controls__prev'
  )
  const ingredientsNavNext = document.querySelector(
    '.pdp__ingredients__header__slider-controls__next'
  )

  const ingredientsSlider = new Swiper('.pdp__ingredients__content__slider', {
    slidesPerView: 1,
    spaceBetween: 16,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    loop: true,
    breakpoints: {
      768: {
        slidesPerView: 2,
        spaceBetween: 8,
        navigation: false,
      },
      1024: {
        slidesPerView: 3,
        spaceBetween: 8,
      },
      1280: {
        slidesPerView: 4,
        spaceBetween: 8,
      },
    },
  })

  function attachIngredientNavButtons() {
    if (!ingredientsNavPrev || !ingredientsNavNext) {
      return
    }

    ingredientsNavPrev.addEventListener('click', () =>
      ingredientsSlider.slidePrev()
    )

    ingredientsNavNext.addEventListener('click', () =>
      ingredientsSlider.slideNext()
    )
  }

  const showAboutOverlay = (e, type) => {
    const top = e.target.closest(
      '.pdp__ingredients__content__slider__wrapper__item'
    )
    const aboutOverlay = top.querySelector(selectors.ingredientAboutOverlayTop)

    if (window.innerWidth < 768 && type === 'clicked') {
      aboutOverlay.style.display = 'flex'
    } else if (window.innerWidth > 767 && type === 'hovered') {
      aboutOverlay.style.display = 'flex'
    } else {
      return
    }
  }

  const showOriginOverlay = (e) => {
    const top = e.target.closest(
      '.pdp__ingredients__content__slider__wrapper__item'
    )
    const originOverlay = top.querySelector(
      selectors.ingredientOriginOverlayTop
    )

    if (window.innerWidth < 768) {
      originOverlay.style.display = 'flex'
    } else {
      originOverlay.style.display = 'flex'
    }
  }

  const hideAboutOverlay = (e, type) => {
    const top = e.target.closest(
      '.pdp__ingredients__content__slider__wrapper__item'
    )
    const aboutOverlay = top.querySelector(selectors.ingredientAboutOverlayTop)

    if (window.innerWidth < 768 && type === 'clicked') {
      return
    } else if (window.innerWidth > 767 && type === 'hovered') {
      aboutOverlay.style.display = 'none'
    } else {
      return
    }
  }

  const hideOriginOverlay = (e) => {
    const top = e.target.closest(
      '.pdp__ingredients__content__slider__wrapper__item'
    )
    const originOverlayTop = top.querySelector(
      selectors.ingredientOriginOverlayTop
    )

    if (window.innerWidth < 768) {
      originOverlayTop.style.display = 'none'
    } else {
      originOverlayTop.style.display = 'none'
    }
  }

  const suggestionsSlider = () => {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) {
        return
      }

      if (!productRecommendationsSection) {
        return
      }

      observer.unobserve(productRecommendationsSection)

      const url = productRecommendationsSection.dataset.url

      fetch(url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement('div')
          html.innerHTML = text

          const recommendations = html.querySelector(
            '.pdp__suggestions__content'
          )

          if (
            productRecommendationsSection &&
            recommendations &&
            recommendations.innerHTML.trim().length
          ) {
            productRecommendationsSection.innerHTML = recommendations.innerHTML
          }

          const suggestionSlider = new Swiper(
            '.pdp__suggestions__content__slider',
            {
              slidesPerView: 1,
              spaceBetween: 16,
              grabCursor: true,
              breakpoints: {
                768: {
                  slidesPerView: 2.5,
                },
                1024: {
                  slidesPerView: 3.7,
                  spaceBetween: 40,
                },
              },
            }
          )

          document
            .querySelector(selectors.suggestionSliderPrevBtn)
            .addEventListener('click', function () {
              suggestionSlider.slidePrev()
            })
          document
            .querySelector(selectors.suggestionSliderNextBtn)
            .addEventListener('click', function () {
              suggestionSlider.slideNext()
            })
        })
        .catch((e) => {
          console.error(e)
        })
    }

    const productRecommendationsSection = document.querySelector(
      '.pdp__suggestions__content'
    )
    const observer = new IntersectionObserver(handleIntersection, {
      rootMargin: '0px 0px 200px 0px',
    })

    if (productRecommendationsSection) {
      observer.observe(productRecommendationsSection)
    }
  }

  const addToCart = async (e) => {
    e.preventDefault()
    const variantId = parseInt(
      document.querySelector(selectors.variantInput).value
    )
    const quantity = document.querySelector(selectors.qtyInput)

    const settings = {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        items: [
          {
            id: variantId,
            quantity: parseInt(quantity.value),
          },
        ],
      }),
    }

    try {
      const res = await fetch('/cart/add.js', settings)
      const data = await res.json()

      if (res.status !== 200) {
        quantity.value = 1
        return
      }

      quantity.value = 1
      Shopify.openCartDrawer()
    } catch (err) {
      console.log(err)
      quantity.value = 1
    }
  }

  if (ingredientAboutBtns.length) {
    ingredientAboutBtns.forEach(function (btn) {
      btn.addEventListener('mouseenter', function (e) {
        showAboutOverlay(e, 'hovered')
      })
      btn.addEventListener('click', function (e) {
        showAboutOverlay(e, 'clicked')
      })
      btn.addEventListener('mouseleave', function (e) {
        hideAboutOverlay(e, 'hovered')
      })
      btn.addEventListener('click', function (e) {
        hideAboutOverlay(e, 'clicked')
      })
    })

    ingredientTopWrappers.forEach(function (wrapper) {
      wrapper.addEventListener('mouseenter', showOriginOverlay)
      wrapper.addEventListener('mouseleave', hideOriginOverlay)
      wrapper.addEventListener('click', showOriginOverlay)
    })

    ingredientOriginBtns.forEach(function (btn) {
      btn.addEventListener('mouseenter', showOriginOverlay)
      btn.addEventListener('mouseleave', hideOriginOverlay)
      btn.addEventListener('click', showOriginOverlay)
    })
  }

  if (document.querySelector(selectors.variantSelect)) {
    document
      .querySelector(selectors.variantSelect)
      .addEventListener('change', function () {
        const variantId = this.options[this.selectedIndex].value
        const price = this.options[this.selectedIndex].dataset.variantPrice

        document.querySelector(selectors.variantInput).value = variantId
        document.querySelector(selectors.priceText).textContent = price
      })
  }

  if (document.querySelector(selectors.atcForm)) {
    document
      .querySelector(selectors.atcForm)
      .addEventListener('submit', addToCart)
  }

  if (document.querySelector(selectors.decQty)) {
    document
      .querySelector(selectors.decQty)
      .addEventListener('click', function () {
        const qtyInput = document.querySelector(selectors.qtyInput)

        if (parseInt(qtyInput.value) <= 1) {
          return
        }

        qtyInput.value = parseInt(qtyInput.value) - 1
      })
  }

  if (document.querySelector(selectors.incQty)) {
    document
      .querySelector(selectors.incQty)
      .addEventListener('click', function () {
        const qtyInput = document.querySelector(selectors.qtyInput)
        qtyInput.value = parseInt(qtyInput.value) + 1
      })
  }

  function attachAboutCloseBtns() {
    const aboutCloseBtns = document.querySelectorAll(selectors.aboutCloseBtn)

    if (!aboutCloseBtns.length) {
      return
    }

    aboutCloseBtns.forEach(function (btn) {
      const top = btn.closest(
        '.pdp__ingredients__content__slider__wrapper__item'
      )
      const aboutOverlay = top.querySelector(
        selectors.ingredientAboutOverlayTop
      )
      btn.addEventListener('click', function () {
        aboutOverlay.style.display = 'none'
      })
    })
  }

  function attachOriginCloseBtns() {
    const originCloseBtns = document.querySelectorAll(selectors.originCloseBtn)

    if (!originCloseBtns.length) {
      return
    }

    originCloseBtns.forEach(function (btn) {
      const top = btn.closest(
        '.pdp__ingredients__content__slider__wrapper__item'
      )
      const originOverlay = top.querySelector(
        selectors.ingredientOriginOverlayTop
      )
      btn.addEventListener('click', function () {
        originOverlay.style.display = 'none'
      })
    })
  }

  function attachOOSForm() {
    if (!document.querySelector(selectors.oosForm)) {
      return
    }

    function handleSubmit(e) {
      e.preventDefault()
      const oosEmailInput = document.querySelector(selectors.oosEmailInput)

      if (oosEmailInput.value.trim() === '') {
        return
      }

      BIS.create(
        oosEmailInput.value.trim(),
        document.querySelector(selectors.oosForm).dataset.variantId,
        document.querySelector(selectors.oosForm).dataset.productId
      ).then((res) => {
        console.log(res)
        if (res.status != 'OK') {
          document.querySelector(selectors.oosSuccessMsg).textContent =
            'Already subscribed to this item'
        }

        document.querySelector(selectors.oosSuccessMsg).style.display = 'flex'
        document.querySelector(selectors.oosForm).style.display = 'none'
      })
    }

    document
      .querySelector(selectors.oosForm)
      .addEventListener('submit', handleSubmit)
  }

  attachOOSForm()
  attachAboutCloseBtns()
  attachOriginCloseBtns()
  suggestionsSlider()
  attachIngredientNavButtons()
})
